import { render, staticRenderFns } from "./SimulationCompetencies.vue?vue&type=template&id=1dd76dfc&scoped=true"
import script from "./SimulationCompetencies.vue?vue&type=script&lang=js"
export * from "./SimulationCompetencies.vue?vue&type=script&lang=js"
import style0 from "./SimulationCompetencies.vue?vue&type=style&index=0&id=1dd76dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd76dfc",
  null
  
)

export default component.exports